import type { JSX } from 'react'
import LinkIcon from '@mui/icons-material/Link'
import { Grid, IconButton, Typography } from '@mui/material'

interface IProps {
  label: string
  value?: string | JSX.Element
  xs?: number
  resourcesLink?: string
}

const DeviceField = ({ label, value, xs = 2, resourcesLink }: IProps) => (
  <Grid
    container={true}
    size={xs}
    sx={{
      justifyItems: 'center',
      alignContent: 'flex-start',
    }}
  >
    <Grid size={12}>
      <Typography
        variant="overline"
        sx={{
          lineHeight: 0.5,
        }}
      >
        {label}
      </Typography>

      {resourcesLink && (
        <IconButton href={resourcesLink} target="_blank" aria-label="View Resources">
          <LinkIcon color="primary" sx={{ fontSize: 16 }} />
        </IconButton>
      )}
    </Grid>

    <Grid size={12}>
      {(typeof value === 'string' || value === undefined || value === null) && <Typography variant="body1">{value || '-'}</Typography>}
      {typeof value !== 'string' && value ? value : undefined}
    </Grid>
  </Grid>
)

export default DeviceField
